import { z } from "zod";

/**
 * `DEPOSIT-D` (`P1-DOS-089`): **the two deposits of a dossier, named side by side when they differ.** The REQUESTED amount (the dossier's price at its `depositPct`) from the opening of the file; the OFFERED amount
 * (the price less the vehicle part the bank finances) once an offer stands. Composed by `composeDeposit` (`@hakili/domain-types`, the one composer); the browser computes nothing, formats the whole francs with
 * `formatMoney` and draws the SERVED words. `differs` is the server's decision. `words` are PROPOSED (owed by A to H).
 *
 * One definition, two readings: `z.strictObject` is the contract, `z.looseObject` the READ twin.
 */
function buildSchemas(object: typeof z.strictObject) {
  return object({
    requestedAmount: z.number().int().min(0),
    /** `null` while no offer stands. */
    offeredAmount: z.number().int().nullable(),
    differs: z.boolean(),
    words: object({
      requestedLabel: z.string().min(1),
      offeredLabel: z.string().min(1),
      /** `null` unless the two differ. */
      differenceSentence: z.string().min(1).nullable(),
    }),
  });
}

export const depositSchema = buildSchemas(z.strictObject);
export const depositReadSchema = buildSchemas(z.looseObject);
export type Deposit = z.infer<typeof depositSchema>;
